import { render, staticRenderFns } from "./AIEventsPanel.vue?vue&type=template&id=08b0e203"
import script from "./AIEventsPanel.vue?vue&type=script&lang=js"
export * from "./AIEventsPanel.vue?vue&type=script&lang=js"
import style0 from "./AIEventsPanel.vue?vue&type=style&index=0&id=08b0e203&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports